<template>
  <v-form v-model="form_validate_status" ref="form" :loading="loading">
    <v-card max-width="750" class="mx-auto" color="grey-lighten-3">
      <v-layout>
        <CustomAppBar :page="3" :title="$t('info_card.title_page3')" />
        <v-main
          ><v-card-text
            ><h3>{{ $t("info_card.school_location") }}</h3>
            <v-row class="pt-3"
              ><v-col class="v-col-12 v-col-sm-6"
                ><h6>{{ $t("info_card.school_type") }}</h6>
                <SchoolType v-model="school_type_id"
              /></v-col>
              <v-col class="v-col-12 v-col-sm-6"
                ><h6>{{ $t("info_card.education_type") }}</h6>
                <EducationType v-model="education_type_id"
              /></v-col> </v-row></v-card-text
          ><v-divider></v-divider
          ><v-card-text v-if="this.school_type_id !== '04'">
            <v-radio-group
              v-model="schoolLocation"
              :mandatory="false"
              row
              v-bind:rules="requiredRules"
            >
              <v-row>
                <v-col cols="12" sm="4">
                  <v-radio
                    v-bind:label="$t('info_card.in_thai')"
                    value="inThai"
                  ></v-radio>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-radio
                    v-bind:label="$t('info_card.foreign_country')"
                    value="foreignCountry"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
            <v-row v-if="schoolLocation === 'inThai'"
              ><v-col cols="12" sm="6"
                ><h6>{{ $t("info_card.province") }}</h6>
                <v-autocomplete
                  variant="outlined"
                  density="compact"
                  v-model="province_id"
                  v-bind:rules="requiredRules"
                  v-bind:items="provinces"
                  v-bind:item-title="
                    (item) => objectTranslator(item, 'PROVINCE_NAME')
                  "
                  v-bind:item-value="(item) => item.PROVINCE_ID"
                  @update:modelValue="update_province"
                ></v-autocomplete></v-col
              ><v-col cols="12" sm="6"
                ><h6>{{ $t("info_card.school_name") }}</h6>
                <v-autocomplete
                  variant="outlined"
                  density="compact"
                  v-model="school_id"
                  v-bind:rules="requiredRules"
                  v-bind:items="filteredSchools"
                  v-bind:item-title="(item) => item.SCHOOL_NAME"
                  v-bind:item-value="(item) => item.SCHOOL_CODE"
                ></v-autocomplete>
                <p v-html="$t('info_card.page3_text')"></p></v-col
            ></v-row>
            <v-row v-if="schoolLocation === 'foreignCountry'"
              ><v-col cols="12" sm="6"
                ><h6>{{ $t("info_card.country") }}</h6>
                <v-autocomplete
                  variant="outlined"
                  density="compact"
                  v-model="nation_id"
                  v-bind:rules="requiredRules"
                  v-bind:items="nations"
                  v-bind:item-title="
                    (item) => objectTranslator(item, 'NATION_NAME')
                  "
                  v-bind:item-value="(item) => item.NATION_ID"
                ></v-autocomplete></v-col
              ><v-col cols="12" sm="6"
                ><h6>{{ $t("info_card.school_name") }}</h6>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  v-model="schoolName"
                  v-bind:rules="requiredRules"
                  v-bind:label="textLabelSurnameTh"
                  v-bind:placeholder="textHintSurnameTh"
                ></v-text-field></v-col
            ></v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text
            ><v-row
              ><v-col cols="12" sm="6">
                <h6>{{ $t("info_card.school_student_id") }}</h6>
                <StudentGSN v-model="school_student_id" /></v-col
              ><v-col cols="12" sm="6"
                ><h6>{{ $t("info_card.school_grad_date") }}</h6>
                <DateSelect
                  v-model="school_grad_date"
                  :rules="requiredRules"
                  :minDate="getYearsModified(-13)"
                  :maxDate="getYearsModified(0)"
                />
                <p>
                  {{ $t("info_card.school_grad_date_detail") }}
                </p></v-col
              ><v-col cols="12" sm="6"
                ><h6>{{ $t("info_card.GPA_hint") }}</h6>
                <GPACard v-model="gpa" /></v-col
              ><v-col cols="12" sm="12"
                ><h3>
                  {{ $t("info_card.first_encounter") }}
                </h3>
                <FirstEncounter
                  v-model="old_kmitl_student"
                /> </v-col></v-row></v-card-text
          ><v-divider></v-divider>
          <v-card-text
            ><div
              class="text-end mb-2 text-red"
              v-if="is_saved_before_page === false"
            >
              {{ $t("info.have_not_fill_page_before") }}
            </div>
            <div class="text-end">
              <v-btn color="primary" size="large" class="mr-2" to="/page2"
                >Back</v-btn
              >
              <v-btn
                color="primary"
                size="large"
                :disabled="is_saved_before_page === false"
                @click="saveData"
                >{{ is_lock_kmitl1 === true ? "Next" : "Save & Next" }}</v-btn
              >
            </div>
          </v-card-text>
        </v-main>
      </v-layout>
    </v-card>
  </v-form>
</template>

<script>
import CustomAppBar from "@/components/info_cards/CustomAppBar.vue";
import SchoolType from "@/components/info_cards/SchoolType.vue";
import EducationType from "@/components/info_cards/EducationType.vue";
import StudentGSN from "@/components/info_cards/StudentGSN.vue";
import DateSelect from "@/components/info_cards/DateSelect.vue";
import GPACard from "@/components/info_cards/GPACard.vue";
import FirstEncounter from "@/components/info_cards/FirstEncounter.vue";

import { objectTranslator } from "@/helper/translator";
import { getById } from "@/helper/filter";
import { getYearsModified } from "@/helper/dateTime";
import PageProvider from "@/services/page.provider";
// import UserProvider from "@/services/user.provider.js";
import validator from "@/helper/validator";

// const genericService = new GenericProvider();
const pageService = new PageProvider();
// const userProvider = new UserProvider();

export default {
  name: "PageThreeOne",
  components: {
    CustomAppBar,
    SchoolType,
    EducationType,
    StudentGSN,
    DateSelect,
    GPACard,
    FirstEncounter,
  },

  data: () => ({
    requiredRules: [validator.required],
    form_validate_status: false,
    loading: false,
    is_lock_kmitl1: true,
    is_saved_before_page: false,

    school_type_id: null,
    education_type_id: null,
    // ThaiOrForeignSchool: {
    schoolLocation: null,
    province_id: null,
    school_id: null,
    nation_id: null,
    schoolName: null,
    // },
    education_nation: null,
    school_grad_date: null,

    gpa: null,
    school_student_id: null,
    school_name: null,
    old_kmitl_student: { studentKMITL: null, oldKMITLStudentID: null },
  }),

  methods: {
    getById,
    objectTranslator,
    getYearsModified,

    update_province() {
      this.school_id = null;
    },
    async getData() {
      this.loading = true;
      this.is_lock_kmitl1 =
        this.surrogated_student_info.LOCK_KMITL1 == "0" ? false : true;

      const data = await pageService.getPage3_1(this.uid).catch((error) => {
        this.$toast.error(JSON.stringify(error.response.data.message));
      });
      if (data.length === 0) {
        this.schoolLocation = "inThai";
      } else {
        if (data.EDUCATION_NATION === "TH") {
          this.schoolLocation = "inThai";
          this.school_id = data.SCHOOL_ID;
          this.province_id = data.SCHOOL_PROVINCE_ID;
        } else {
          this.schoolLocation = "foreignCountry";
          this.schoolName = data.SCHOOL_NAME;
        }
      }
      this.nation_id = data.EDUCATION_NATION;
      this.school_type_id = data.SCHOOL_TYPE_ID;
      this.education_type_id = data.EDUCATION_TYPE_ID;
      this.school_grad_date = new Date(data.SCHOOL_GRAD_DATE);
      this.gpa = data.GPA;
      this.school_student_id = data.SCHOOL_STUDENT_ID;
      if (data.OLD_KMITL_STUDENT_ID) {
        this.old_kmitl_student.studentKMITL = "reEntry";
        this.old_kmitl_student.oldKMITLStudentID = data.OLD_KMITL_STUDENT_ID;
      } else {
        this.old_kmitl_student.studentKMITL = "firstTime";
      }
      this.loading = false;
    },

    async saveData() {
      if (this.form_validate_status === true) {
        if (this.is_lock_kmitl1 === false) {
          this.loading = true;
          if (this.schoolLocation === "inThai") {
            this.education_nation = "TH";
          } else {
            this.education_nation = this.nation_id;
            this.school_name = this.schoolName;
          }
          const school_grad_date = this.$dayjs(this.school_grad_date).format(
            "YYYY-MM-DD"
          );
          const response = await pageService
            .setPage3_1({
              uid: this.uid,
              SCHOOL_TYPE_ID: this.school_type_id ?? null,
              EDUCATION_TYPE_ID: this.education_type_id ?? null,
              SCHOOL_STUDENT_ID: this.school_student_id ?? null,
              SCHOOL_GRAD_DATE: school_grad_date ?? null,
              GPA: this.gpa ?? null,

              EDUCATION_NATION: this.education_nation ?? null,
              SCHOOL_ID: this.education_nation == "TH" ? this.school_id : null,
              SCHOOL_NAME: this.school_name ?? null,
              OLD_KMITL_STUDENT_ID:
                this.old_kmitl_student.studentKMITL === "reEntry"
                  ? this.old_kmitl_student.oldKMITLStudentID
                  : null,
            })
            .catch((error) => {
              this.$toast.error(JSON.stringify(error.response.data.message));
              this.loading = false;
            });
          if (response && response.status) {
            this.$toast.success(this.$t("toast.save_successfully"));
            this.$router.push("/page4");
          } else this.$toast.error(this.$t("toast.cannot_save"));
          this.loading = false;
        } else {
          this.$router.push("/page4");
        }
      } else {
        this.$toast.error(this.$t("toast.cannot_save"));
      }
    },
  },

  computed: {
    schools() {
      return this.$store.state.ref.schools;
    },
    provinces() {
      return this.$store.state.ref.provinces;
    },
    nations() {
      return this.$store.state.ref.nations;
    },

    filteredSchools() {
      let data = this.schools;
      if (this.province_id) {
        data = data.filter((item) => item.PROV_ID === this.province_id);
      }
      return data;
    },

    uid() {
      return this.$store.state.user.surrogated_student_uid;
    },

    surrogated_student_info() {
      return this.$store.state.user.surrogated_student_info;
    },
  },

  async created() {
    await this.$store.dispatch("user/getUserInfo");
    this.is_saved_before_page =
      this.surrogated_student_info.ENTERED.includes("2");
    if (this.is_saved_before_page === false) {
      this.$router.push("/main");
    }

    this.$store.dispatch("ref/getProvinces");
    this.$store.dispatch("ref/getSchools");
    this.$store.dispatch("ref/getNations");

    this.getData();
  },
};
</script>
<style scoped></style>
